module.exports = ":host{display:inline-block;height:var(--lui-icon-size,var(--lui-line-height));width:var(--lui-icon-size,var(--lui-line-height))}:host,svg{vertical-align:top}svg{height:100%;transition:var(--lui-transitions-default);width:100%}circle:not([fill]):not([class]),ellipse:not([fill]):not([class]),path:not([fill]):not([class]),polygon:not([fill]):not([class]),polyline:not([fill]):not([class]),rect:not([fill]):not([class]){fill:currentColor}"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-icon/theme/lui-icon.scss
// module id = 216
// module chunks = 0 1 12